export class UploadedFileResponse {
    public fileId: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/entity/uploaded-file-response.ts